import gql from 'graphql-tag'

/**
 * Query
 */
const GET_BOLETAS_REPORT_BY_FILTER = gql`
  query getReportBoletas($input: FilterReportBoletas!) {
    getReportBoletas(input: $input) {
      items {
        employee {
          id
          uid
          email
          name
          last_name
          mothers_last_name
          fullName
          fullLastName
          document_type
          document_number
          phone_number
        }
        year
        mes
        mestext
        importe
        fecha
        estado
        obs
        numero
      }
    }
  }
`

export {
  GET_BOLETAS_REPORT_BY_FILTER
}
